
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action } from "vuex-class";
import { Prop } from "vue-property-decorator";
import { AxiosResponse } from "axios";
import toast from "@/functions/toast.function";

@Component({
  components: {
  },
  filters,
})
export default class ModalReject extends Vue {
  @Action("actionReject", { namespace: "partnership" })
  private actionReject: any;

  @Prop({default: false})
  private show: boolean;
  @Prop({default: 0})
  private id: number;
  @Prop({default: 0})
  private tempId: number;

  private note: string = "";

  private reset() {
    this.note = "";
    this.$emit("close");
  }

  private submit() {
    if (!this.note) {
      toast.warning(this.$t("company_partnership_validate_note"));
      return;
    }
    this.actionReject({
      params: {
        id: this.id,
        temp_id: this.tempId,
        note: this.note,
      },
      success: (response: AxiosResponse) => {
        if (response) {
          toast.success("Rejected.");
          this.$emit("submit");
        }
      },
    });
  }
}
